export { default as LogoNestle } from './LogoNestle'
export { default as LogoPartnerMiimosa } from './LogoPartnerMiimosa'
export { default as LogoBirdNestle } from './LogoBirdNestle'
export { default as HeartOutlineNestle } from './HeartOutlineNestle'
export { default as HeartFillNestle } from './HeartFillNestle'
export { default as GenerationRegeneration } from './GenerationRegeneration'
